import React, { useEffect, useState, useRef } from "react";
import QuoteyBrand from "../general/QuoteyBrand";
import * as theme from "../theme";
import FlexCenter from "../general/FlexCenter";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import NotificationIcon from "@material-ui/icons/NotificationImportantRounded";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Popover, makeStyles, Badge } from "@material-ui/core";
import {
  brokerLoggedOut,
  getBrokerInformation,
  verifyToken,
  fetchReminderCount,
  getUserRoles,
  getProvinces,
  getIsUserVerified,
  updateBrokerLanguagePreference,
} from "../store/broker";
import {
  updateDetails,
  updateUserLanguagePreference,
  updateLanguagePreference,
} from "../store/userManagement";
import {
  getDoNotShowNavigationButtons,
  getLoginModalState,
  getNavigationPageStatus,
  getQFuserMode,
  loginModalOpened,
  bugModalOpened,
  getAutoreminderState,
  reminderModalSet,
} from "../store/components";

import {
  getCategoryList,
  getClientList,
  getGroupList,
  getGroupSelectArray,
  createRemider,
  getReminderCategoryList,
} from "../store/myreminder";

import Login from "./Login";
import Modal from "react-modal";
import { Button } from "react-bootstrap";
import { BROKER, CLIENT, INSURER } from "../store/businesslogic/hardwiredlogic";
import BugModal from "../bugreport/BugModal";
import SuccessStatusModal from "../bugreport/SuccessStatusModal";
import ErrorStatusModal from "../bugreport/ErrorStatusModal";
import { Switch, FormControlLabel } from "@material-ui/core";
import { getMyQuotes } from "../store/myquotes";
import { getMyBinders } from "../store/mybinder";
import { AddReminderPopUp, ReminderPopOver } from "./ReminderModal";

export const PossibleNaviationPages = {
  newquote: "NEW_QUOTE",
  myquotes: "MY_QUOTES",
  mycustomers: "MY_CUSTOMERS",
  mypolicies: "MY_POLICIES",
  bindpolicies: "BIND_POLICIES",
  reminders: "REMINDERS",
  brokeradmin: "BROKER_ADMIN",
  quoteyadmin: "QUOTEY_ADMIN",
  useradmin: "USER_ADMIN",
  bugreport: "BUG_REPORT",
  howtovideos: "HOWTO_VIDEOS",
  dashboard: "DASHBOARD",
};
const translations = {
  en: {
    navigation: {
      newProspect: "New Prospect",
      myProspects: "My Prospects",
      myBinders: "My Binders",
      dashboard: "Dashboard",
      feedback: "Feedback",
      help: "Help",
      logout: "Logout",
      settings: "Settings",
    },
  },
  fr: {
    navigation: {
      newProspect: "Nouveau client ",
      myProspects: "Mes clients",
      myBinders: "Mes certificats",
      dashboard: "Tableau de bord",
      feedback: "Commentaire",
      help: "Aide",
      logout: "Déconnection​",
      settings: "Paramètres",
    },
  },
};

const Navigation = () => {
  const dispatch = useDispatch();
  let history = useNavigate();
  let navigate = useNavigate();
  const broker = useSelector(getBrokerInformation);
  // const languagepreference = broker.information.languagepreference;
  // const languagecode = broker.information.languagepreference || "en";

  const qfUserMode = useSelector(getQFuserMode);
  const isUserVerify = useSelector(getIsUserVerified);
  const doNotShowNavigationButtons = useSelector(getDoNotShowNavigationButtons);
  const [language, setLanguage] = useState("en");
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [showAddReminder, setshowAddReminder] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    dispatch(getGroupList());
    dispatch(getClientList());
    dispatch(getReminderCategoryList());
  }, []);

  useEffect(() => {
    dispatch(getUserRoles());
    dispatch(verifyToken());
    dispatch(getProvinces());

    // setLanguage(languagepreference);
  }, [dispatch]);

  useEffect(() => {
    sessionStorage.setItem("language", "en");
  }, []);

  useEffect(() => {
    //console.log("supra", broker?.information);
    if (broker?.information?.languagepreference) {
      setLanguage(broker.information.languagepreference);
    }
  }, [broker]);

  // Email verification is now handled by the EmailVerification component
  // This function has been removed to avoid duplicate handling
  useEffect(() => {
    // handleSignInVarify() - Removed: Now handled by EmailVerification component
    dispatch(getMyQuotes(null));
    dispatch(getMyBinders({ statusid: "625e922d580769d01b1c2160" }));
    if (buttonRef.current) {
      setAnchorEl(buttonRef.current); // Set the ref as the anchorEl
      //setshowAddReminder(true)
      dispatch(reminderModalSet(true));
    }
  }, [buttonRef]);

  const handleToggle = (event) => {
    const newLanguage = event.target.checked ? "fr" : "en";
    setLanguage(newLanguage);

    // Save language in session storage
    sessionStorage.setItem("language", newLanguage);
    dispatch(updateUserLanguagePreference(newLanguage));
    if (broker?.information) {
      dispatch(updateBrokerLanguagePreference(newLanguage));

      // Update language preference in the store
      const langSelected = {
        label: newLanguage === "fr" ? "French" : "English",
        value: newLanguage,
      };

      dispatch(
        updateLanguagePreference({
          id: broker.information.user._id,
          languagePreference: langSelected,
        })
      );
      console.log("Language switched to", newLanguage);
    }
  };

  const widthDivison = {
    quoteybrand: qfUserMode == "client" ? "20%" : "10%",
    navigationoptions: "",
    bugreport: language == "fr" ? "8%" : "6%",
    brokeradminpanel: "10%",
    loginlogout: "10%",
  };

  widthDivison.navigationoptions = `calc(100% - ${widthDivison.quoteybrand} - ${widthDivison.bugreport} - ${widthDivison.brokeradminpanel} - ${widthDivison.loginlogout})`;
  const displayButtonBadge = broker.information?.unViewedReminderCount
    ? "block"
    : "none";
  return (
    <React.Fragment>
      <div
        style={{
          ...theme.fwfh,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            width: widthDivison.quoteybrand,
            height: "100%",
            alignSelf: "flex-start",
          }}
        >
          <QuoteyBrand></QuoteyBrand>
        </div>

        {qfUserMode === BROKER ? (
          <div
            style={{
              width: widthDivison.navigationoptions,
              height: "100%",
              alignSelf: "center",
            }}
          >
            {/* Here comes the navigation options */}
            {isUserVerify && !doNotShowNavigationButtons ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  color: "white",
                  fontFamily: "GibsonLight",
                  fontWeight: "bold",
                }}
              >
                <ANavigationButton
                  text={translations[language]?.navigation.newProspect}
                  pagecode={PossibleNaviationPages.newquote}
                />
                <ANavigationButton
                  text={translations[language]?.navigation.myProspects}
                  pagecode={PossibleNaviationPages.myquotes}
                />
                <ANavigationButton
                  text={translations[language]?.navigation.myBinders}
                  pagecode={PossibleNaviationPages.bindpolicies}
                />
                <ANavigationButton
                  text={translations[language]?.navigation.dashboard}
                  pagecode={PossibleNaviationPages.dashboard}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : null}
        {isUserVerify && !doNotShowNavigationButtons && qfUserMode != CLIENT ? (
          <>
            <div
              style={{
                width: widthDivison.bugreport,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                color: "white",
                fontFamily: "GibsonLight",
                fontWeight: "bold",
              }}
            >
              <ANavigationButton
                text={translations[language]?.navigation.feedback}
                pagecode={PossibleNaviationPages.bugreport}
              />
            </div>
            <div
              style={{
                width: widthDivison.bugreport,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                color: "white",
                fontFamily: "GibsonLight",
                fontWeight: "bold",
              }}
            >
              {language === "en" && (
                <ANavigationButton
                  text={translations[language]?.navigation.help}
                  pagecode={PossibleNaviationPages.howtovideos}
                />
              )}
            </div>
            <div className="nav-notification">
              <ANavigationButton
                text={
                  <>
                    <div style={{ position: "relative", paddingRight: "1em" }}>
                      <Badge
                        badgeContent={broker.information?.unViewedReminderCount} // Number of notifications
                        color="error" // Red badge
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <NotificationIcon style={{ fontSize: "1.3rem" }} />
                      </Badge>
                    </div>

                    <AddCircleOutlineIcon
                      ref={buttonRef}
                      onClick={(e) => {
                        e.stopPropagation();
                        setAnchorEl(e.currentTarget);
                        //setshowAddReminder(true)
                        dispatch(reminderModalSet(true));
                      }}
                    />
                    <ReminderPopOver
                      id="add-reminder-icon"
                      setAnchorEl={setAnchorEl}
                      anchorEl={anchorEl}
                      setshowAddReminder={setshowAddReminder}
                      showAddReminder={showAddReminder}
                    />
                  </>
                }
                pagecode={PossibleNaviationPages.reminders}
              />
            </div>
          </>
        ) : null}
        <div
          style={{
            width: widthDivison.brokeradminpanel,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            color: "white",
            fontFamily: "GibsonLight",
            fontWeight: "bold",
          }}
        >
         {broker.istokenvalid &&
  qfUserMode !== CLIENT &&
  !doNotShowNavigationButtons && (
    <>
      {broker.issuperadmin && (
        <ANavigationButton
          text={"Quotey Admin"}
          pagecode={PossibleNaviationPages.quoteyadmin}
        />
      )}
      {broker.isadmin && !broker.issuperadmin && (
        <ANavigationButton
          text={"Admin"}
          pagecode={PossibleNaviationPages.brokeradmin}
        />
      )}
      <ANavigationButton
        text={translations[language]?.navigation.settings || "Settings"}
        pagecode={PossibleNaviationPages.useradmin}
      />
    </>
)}

        </div>
        <div
          style={{
            width: widthDivison.brokeradminpanel,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontFamily: "GibsonLight",
            fontWeight: "bold",
            marginTop: "4px",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={language === "fr"}
                onChange={handleToggle}
                name="languageToggle"
                color="primary"
              />
            }
            label={
              <span
                style={{
                  fontFamily: "GibsonLight",
                  fontWeight: "bold",
                }}
              >
                {language === "fr" ? "Français" : "English"}
              </span>
            }
          />
        </div>
        {qfUserMode === CLIENT || qfUserMode === INSURER ? null : (
          <div
            style={{
              width: widthDivison.loginlogout,
              height: "100%",
              alignSelf: "flex",
            }}
          >
            {isUserVerify && !doNotShowNavigationButtons ? (
              <LogOut></LogOut>
            ) : !doNotShowNavigationButtons ? (
              <></>
            ) : (
              <></>
            )}
          </div>
        )}
      </div>
      {/* <ul>
        <li>
          <Link to="/prospect">ApplicationScreen</Link>
        </li>
        <li>
          <Link to="/">Home</Link>
        </li>
      </ul> */}

      <BugModal></BugModal>

      {/* Status modals - Success and Error - for the Bug Report form */}
      <SuccessStatusModal></SuccessStatusModal>
      <ErrorStatusModal></ErrorStatusModal>
      {/* <Login></Login> */}
      {/* <LoginModal></LoginModal> */}
    </React.Fragment>
  );
};

const ANavigationButton = ({ text, pagecode }) => {
  const dispatch = useDispatch(); // Just for the bug report
  const [hovering, setHovering] = useState(false);
  const isPageActive = useSelector(getNavigationPageStatus({ pagecode }));
  const navigate = useNavigate();
  return (
    <div
      style={{
        width: "150px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        cursor: "pointer",
        fontFamily: hovering || isPageActive ? "GibsonSemiBd" : "GibsonLight",
        backgroundColor:
          hovering || isPageActive
            ? isPageActive
              ? theme.COLORS.dark_navy_blue
              : theme.COLORS.navigation_hovering
            : "inherit",
        letterSpacing: hovering || isPageActive ? 1 : 2,
        color:
          hovering || isPageActive
            ? isPageActive
              ? "white"
              : theme.COLORS.primary_navyblue
            : theme.COLORS.navigation_hovering,
        fontSize: hovering ? "1.5vmin" : "1.3vmin",
        borderRadius: "4px",
      }}
      onMouseOver={() => {
        setHovering(true);
      }}
      onMouseLeave={() => {
        setHovering(false);
      }}
      onClick={() => {
        if (pagecode === PossibleNaviationPages.myquotes) {
          document.location.href = "/myquotes";
          //navigate("/myquotes")
        }
        if (pagecode === PossibleNaviationPages.newquote) {
          document.location.href = "/";
          //navigate("/")
        }
        if (pagecode === PossibleNaviationPages.mypolicies) {
          document.location.href = "/mypolicies";
          //navigate("/mypolicies")
        }
        if (pagecode === PossibleNaviationPages.bindpolicies) {
          document.location.href = "/bindpolicies";
          //navigate("/bindpolicies")
        }
        if (pagecode === PossibleNaviationPages.reminders) {
          document.location.href = "/reminders";
          //navigate("/reminders")
        }
        if (pagecode === PossibleNaviationPages.brokeradmin) {
          document.location.href = "/brokeradmin/details";
          //navigate("/brokeradmin/details")
        }
        if (pagecode === PossibleNaviationPages.quoteyadmin) {
          document.location.href = "/quoteyadmin/home";
          //navigate("/quoteyadmin/home")
        }
        if (pagecode === PossibleNaviationPages.bugreport) {
          dispatch(bugModalOpened());
        }
        if (pagecode === PossibleNaviationPages.howtovideos) {
          document.location.href = "/howtoVideos";
          //navigate("/howtoVideos")
        }
        if (pagecode === PossibleNaviationPages.dashboard) {
          document.location.href = "/dashboard";
          //navigate("/dashboard")
        }
        if (pagecode === PossibleNaviationPages.useradmin) {
          document.location.href = "useradmin/user";
        }
      }}
    >
      {text}
    </div>
  );
};

const LoginAndRegister = () => {
  const dispatch = useDispatch();

  const handleSignIn = () => {
    dispatch(loginModalOpened());
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100%",
        fontFamily: "GibsonRegular",
      }}
    >
      <div style={{ width: "100%", height: "100%" }}>
        <FlexCenter style={{ color: "white" }}>
          <Button
            variant="link"
            onClick={handleSignIn}
            style={{
              color: "white",
              fontFamily: "GibsonSemiBd",
            }}
          >
            Sign In
          </Button>
        </FlexCenter>
      </div>
    </div>
  );
};

const LogOut = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [language, setLanguage] = useState("en");
  const broker = useSelector(getBrokerInformation);

  useEffect(() => {
    if (broker?.information?.languagepreference) {
      setLanguage(broker.information.languagepreference);
    }
  }, [broker]);

  return (
    <FlexCenter style={{ color: "white", fontFamily: "GibsonSemiBd" }}>
      <Button
        variant="link"
        onClick={() => {
          dispatch(brokerLoggedOut()).then(
            () =>
              //history("/")
              (document.location.href = "/")
          );
        }}
        style={{
          color: "white",
        }}
      >
        {translations[language]?.navigation.logout}
      </Button>
    </FlexCenter>
  );
};

const LoginModal = (props) => {
  const loginModalState = useSelector(getLoginModalState);
  return (
    <Modal
      isOpen={loginModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "90vh",
          width: "60%",
          position: "absolute",
          top: "7vh",
          left: "-1vw",
          right: 0,
          bottom: 0,
          background: theme.COLORS.tertiary_ligthindigo,
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
          margin: "0 auto",
        },
      }}
    >
      <Login></Login>
    </Modal>
  );
};

export default Navigation;
